import Fetch, { pageInfo } from './fetch';
import FetchUpload from './fetchUpload';
import Qs from 'qs'
import store from '@/stores';
const accountRequests = {
  requestToken(user) {
    return Fetch({
      url: '/login',
      method: 'post' ,
      data:Qs.stringify(user),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    });
  },
  /**
   * 获取登录用户信息
   */
  getLoginUserInfo() {
    return new Promise((resolve, reject) => {
      let user = store.getters.user;
    resolve(user)
  });
    // return Fetch({
    //     url: '/sys/loginuser',
    //     method: 'get'
    // });
  },
  getSign(formdata){
    return Fetch({
      url: '/oss/v_sign',
      method: 'post',
      data:Qs.stringify(formdata)   ,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  },
  ossDelete(key)
  {
    return Fetch({
      url: '/oss/delete?ossKey='+key,
      method: 'post',
    });
  },
  /**
   * 上传文件
   * @param {*} data 上传的文件
   * @param {any} fileType 文件类型[pic、video、audio、attach]
   * @returns filePath
   */

  uploadFile(data, host, callBack, cancelToken ) {
    return FetchUpload({
      url: host,
      headers: { 'Content-Type': 'multipart/form-data' },
      method: 'post',
      data: data,
      isLocal: true,
      onUploadProgress: progressEvent => {
      if (callBack) {
        // console.log(progressEvent);
        callBack(progressEvent.loaded / progressEvent.total * 100 | 0,data.name);
      }
    },
      cancelToken: cancelToken

  });

  },
  getIndexCount()
  {
    return Fetch({
      url: '/userIndex/getIndexCount/',
      method: 'get'
    });
  }


}
export default accountRequests;



// WEBPACK FOOTER //
// ./src/api/system.js